import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'posttag/';

export const DeletePostTag = async (recordPk) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: recordPk
        });
        return "Deleted PostTags";
    } catch (error) {
        console.error('Error deleting the tags:', error);
    }
};

export const GetAllPostTags = async (recordPk) => {
    try {
        const response = await fetch(baseURL + `getall?postPk=${recordPk}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all records:', error);
    }
};

export const AddPostTags = async (recordBody) => {
    console.log("recordBody:", recordBody);
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: recordBody
        });
        return "Record added";
    } catch (error) {
        console.error('Error adding record:', error);
    }
};
